<template>
  <div class="task-section">
    <p class="task-section__title">Create a new task</p>
    <form action class="task-form">
      <div class="task-form__row">
        <label for="schemeSelect" class="task-form__label">scheme</label>
        <select name="schemeSelect" v-model="scheme" class="task-form__select">
          <option v-for="item in selectSchemes" :key="item.id">{{
            item.name
          }}</option>
        </select>
      </div>
      <div class="task-form__row">
        <label for="studySelect" class="task-form__label">study</label>
        <select name="studySelect" v-model="study" class="task-form__select">
          <option v-for="item in selectStudies" :key="item.id">{{
            item.name
          }}</option>
        </select>
      </div>
      <p-button
        size="sm"
        type="submit"
        style="line-height: 2.4;"
        @click.native="submitTaskForm"
        >Create</p-button
      >
    </form>
  </div>
</template>
<script>
import { devUrl } from "../../../settings";
import EmptyFieldsError from "../../Notifications/EmptyFieldsError";
import CreateTask from "../../Notifications/CreateTask";

export default {
  data() {
    return {
      scheme: "",
      study: ""
    };
  },
  computed: {
    selectStudies() {
      return this.$store.getters.getStudiesForSelect;
    },
    selectSchemes() {
      return this.$store.getters.schemes;
    }
  },
  methods: {
    submitTaskForm() {
      if (this.scheme === "" || this.study === "") {
        this.$notify({
          component: EmptyFieldsError,
          icon: "ti-alert",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger"
        });
        return;
      }
      const schemeId = this.selectSchemes.find(i => i.name === this.scheme).id;
      const studyId = this.selectStudies.find(i => i.name === this.study).id;

      this.$store
        .dispatch("postTask", {
          scheme: `${devUrl}schemes/${schemeId}/`,
          study: `${devUrl}studies/${studyId}/`
        })
        .then(() => {
          this.scheme = "";
          this.study = "";
          this.$store.dispatch("fetchTasks", 1);
        })
        .then(() =>
          this.$notify({
            component: CreateTask,
            icon: "ti-gift",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success"
          })
        );
    }
  },
  created() {
    this.$store.dispatch("fetchStudies", 1);
    this.$store.dispatch("fetchSchemes", 1);
  }
};
</script>
<style lang="scss" scoped>
.task-section {
  &__title {
    border-bottom: 1px solid #dddddd;
    font-size: 20px;
    padding: 5px 0px;
  }
}

.task-form {
  text-align: center;

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__label {
    font-size: 16px;
    font-weight: bold;
  }

  &__select {
    width: 195px;
    padding: 10px 2px;
    border: none;
    border-radius: 4px;
    margin-bottom: 1rem;
  }
}
</style>
